/*
 * @Description:
 * @Author: tongjunyi<tongjunyi@didiglobal.com>
 * @Date: 2023-08-02 20:01:10
 * @LastEditors: tongjunyi
 * @LastEditTime: 2023-08-15 15:29:47
 */
import { Layout } from '@didi-pebble/pebble-design-react';
import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect, useState } from 'react';

import logo99 from '@/assets/images/logo99.png';
import siderIcon from '@/assets/images/sider_icon.png';
import { useIsMobile } from '@/utils';
import { headTitleAtom, setSiderOpen } from '@/store';

import UserInfo from './userInfo';
import CodeInfo from './codeInfo';
import CsInfo from './csInfo';

const { Header } = Layout;

const HeaderComp: React.FC = () => {
  const isMobile = useIsMobile();
  const headTitle: any = useAtomValue(headTitleAtom);
  const toSetSiderOpen = useSetAtom(setSiderOpen);
  const [mobileCsShow, setMobileCsShow] = useState(false);

  useEffect(() => {
    setMobileCsShow(true);
  }, []);

  return (
    <>
      {isMobile ? (
        <Header
          className='flex items-center justify-between'
          style={{
            paddingInline: '18px 20px',
            height: 48,
            backgroundColor: '#FFF',
            boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.08)',
            position: 'relative'
          }}
        >
          <div className='flex items-center'>
            <img
              src={siderIcon}
              width={16}
              height={16}
              style={{ position: 'absolute', left: 20 }}
              onClick={() => {
                toSetSiderOpen(true);
              }}
            />
          </div>
          <div>
            <span className='font-DiDiSansPro-Bold text-base text-[#333] ml-[10px]'>
              {headTitle}
            </span>
          </div>
          <div className='flex items-center'>{mobileCsShow && <CsInfo onlyIcon={true} />}</div>
        </Header>
      ) : (
        <Header
          className='flex justify-between items-center'
          style={{ paddingInline: '32px 20px', height: 48, backgroundColor: '#E9EAEE' }}
        >
          <div className='flex'>
            <img src={logo99} width={30} height={30} style={{ borderRadius: 4 }} />
            <span className='font-DiDiSansPro-Medium text-xl text-[#333] ml-[10px]'>
              99Abastece
            </span>
          </div>
          <div className='cursor-pointer flex items-center'>
            <CodeInfo />
            <CsInfo />
            <UserInfo />
          </div>
        </Header>
      )}
    </>
  );
};

export default HeaderComp;
